var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, createContext, useState } from 'react';
import { app } from '../app';
var LocalizationContext = createContext({});
export var useLocale = function () { return useContext(LocalizationContext); };
var LocalizationContextProvider = function (_a) {
    var children = _a.children;
    var translator = app().translator;
    var _b = useState(translator.getLocale()), locale = _b[0], setLocaleState = _b[1];
    var setLocale = function (locale) {
        translator.setLocale(locale);
        setLocaleState(locale);
    };
    var __ = function (key) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        return translator.translate.apply(translator, __spreadArray([key], values, false));
    };
    return (_jsx(LocalizationContext.Provider, __assign({ value: { locale: locale, __: __, setLocale: setLocale } }, { children: children })));
};
export default LocalizationContextProvider;
